import { mlvScrollToTop } from './mlvScrollTop.js';

/**
 * Sincroniza la UI con el estado guardado en history.state (popstate / baseline).
 * Recibe un contexto mutable poblado por el bootstrap.
 */
export function createApplyMlvHistoryState(ctx) {
  return async function applyMlvHistoryState(state) {
    mlvScrollToTop();
    const {
      getFirebase,
      loginView,
      showCatalogoHomePlain,
      renderProfileView,
      showAdminPanelView,
      catalogoPublicoPresenter,
      perfilVentasPresenter,
      productoFeedVerticalPresenter,
      vendedorPresenter,
      vendedorRepository,
      vendedorExperienciaInfoPresenter,
      premiumPlanPresenter,
      isProfileComplete,
      navigation,
      serviciosPresenters,
    } = ctx;

    if (!state || state.t === 'catalog') {
      showCatalogoHomePlain();
      return;
    }
    if (state.t === 'login') {
      loginView();
      return;
    }
    if (state.t === 'profile') {
      await renderProfileView();
      return;
    }
    if (state.t === 'vendedorInfo') {
      if (!getFirebase().auth.currentUser) {
        loginView();
        return;
      }
      vendedorExperienciaInfoPresenter.show({ onBack: () => navigation.goBack() });
      return;
    }
    if (state.t === 'premiumPlan') {
      const u = getFirebase().auth.currentUser;
      if (!u) {
        loginView();
        return;
      }
      const p = await vendedorRepository.syncUserProfile(u.uid, u.email);
      premiumPlanPresenter.show({
        onBack: () => navigation.goBack(),
        profile: p,
        user: u,
      });
      return;
    }
    if (state.t === 'admin') {
      await showAdminPanelView();
      return;
    }
    if (state.t === 'servicios') {
      if (!getFirebase().auth.currentUser) {
        loginView();
        return;
      }
      if (!serviciosPresenters) {
        showCatalogoHomePlain();
        return;
      }
      if (state.mode === 'miPerfil') {
        await serviciosPresenters.showServiciosMiPerfil();
        return;
      }
      if (state.mode === 'ficha' && state.uid) {
        await serviciosPresenters.showServiciosFicha(String(state.uid).trim());
        return;
      }
      await serviciosPresenters.showServiciosHome();
      return;
    }
    if (state.t === 'product' && state.id) {
      catalogoPublicoPresenter.showProductoDetalle(
        state.id,
        navigation.buildProductoDetalleOpts()
      );
      return;
    }
    if (state.t === 'perfilVendedor' && state.uid) {
      await perfilVentasPresenter.show({
        vendedorUid: String(state.uid).trim(),
        onBack: () => navigation.goBack(),
        onOpenProducto: (id) => navigation.pushProductDetail(id),
      });
      return;
    }
    if (state.t === 'feed' && state.startId) {
      await productoFeedVerticalPresenter.showFeed({
        categoriaId: state.categoriaId || 'general',
        startProductId: state.startId,
        isAuthenticated: Boolean(getFirebase().auth.currentUser),
        ...navigation.buildFeedOpts(),
      });
      return;
    }
    if (state.t === 'vendedor') {
      const u = getFirebase().auth.currentUser;
      if (!u) {
        loginView();
        return;
      }
      if (state.mode === 'publicar') {
        await vendedorPresenter.showPublicarForm();
        return;
      }
      if (state.mode === 'mis') {
        await vendedorPresenter.showMisPublicaciones(
          u.uid,
          navigation.misPublicacionesBackOpts()
        );
        return;
      }
      if (state.mode === 'telefono') {
        const p = await vendedorRepository.syncUserProfile(u.uid, u.email);
        if (!isProfileComplete(p)) {
          navigation.replaceVendedorDatos();
          vendedorPresenter.datosVendedorView(p);
          return;
        }
        await vendedorPresenter.showCambiarTelefonoContacto(p, {
          onBack: () => navigation.goBack(),
        });
        return;
      }
      if (state.mode === 'panel') {
        await vendedorPresenter.showPublicarForm();
        return;
      }
      const p = await vendedorRepository.syncUserProfile(u.uid, u.email);
      vendedorPresenter.datosVendedorView(p);
    }
  };
}
